<template>
	<div class="reply-box">
		<div class="reply-selected-types">
			<div class="reply-selected-type" 
			:class="{'reply-selected-type-active':type=='normal'?true:false}" 
			@click="typeClick('normal')">
				<span>普通消息</span>
			</div>
			<div class="reply-selected-type" 
			:class="{'reply-selected-type-active':type=='program'?true:false}" 
			@click="typeClick('program')">
				<span>小程序</span>
			</div>
			<div class="reply-selected-type"
			:class="{'reply-selected-type-active':type=='quickly_tech'?true:false}" 
			@click="typeClick('quickly_tech')" v-if="quicklyTechPlug == 1">
				<span>智能快捷语</span>
			</div>
		</div>
		<div v-if="tabType == 'basic'">
			<div class="reply-selected-tabs">
				<div class="reply-selected-tab" 
				:class="{'reply-selected-tab-active':tab=='personal'?true:false}" 
				@click="tabClick('personal')">
					<span>个人快捷语</span>
				</div>
				<div class="reply-selected-tab" 
				:class="{'reply-selected-tab-active':tab=='public'?true:false}" 
				@click="tabClick('public')">
					<span>公共快捷语</span>
				</div>
				<div class="reply-selected-tab" 
				:class="{'reply-selected-tab-active':tab=='unit'?true:false}" 
				@click="tabClick('unit')">
					<span>部门快捷语</span>
				</div>
			</div>
			<div class="reply-selected-search" v-show="!showEdit">
				<div class="reply-search-input">
					<input type="text" placeholder="快捷语" v-model="kewords">
				</div>
				<div class="reply-refresh" @click="refresh">
					<span></span>
				</div>
				<div class="reply-refresh">
					<span class="reply-add" @click="showEdit=true"></span>
				</div>
			</div>
			<div class="reply-selected-lists" v-show="!showEdit">
				<div class="reply-selected-wrap">
					<chat-info-reply-list :kewords="kewords" :type="type" :tab="tab" @reply-click-call="replyClickCall($event)" ref="cirl"></chat-info-reply-list>
				</div>
			</div>
			<chat-info-reply-edit v-show="showEdit" @reply-edit-call="replyEditCall($event)"></chat-info-reply-edit>
		</div>
		<div v-else>
			<chat-info-reply-extend :chatting="chatting"></chat-info-reply-extend>
		</div>
	</div>
</template>

<script>
	import  ChatInfoReplyEdit from './ChatInfoReplyEdit.vue'
	import ChatInfoReplyList from './ChatInfoReplyList.vue'
	import ChatInfoReplyExtend from './ChatInfoReplyExtend.vue'
	import {getLocalConfig} from '../../../functions/Common.js'
		
	export default {
		name:'HomeInfoReply',
		props:{
			  chatting:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			  }
		},
		data(){
			return {
				kewords: '',
				type:'normal',
				tab:'personal',
				showEdit: false,
				tabType: 'basic',
				quicklyTechPlug: 0
			}
		},
		components:{
			ChatInfoReplyEdit,
			ChatInfoReplyList,
			ChatInfoReplyExtend
		},
		methods:{
			// 大分类点击
			typeClick(val){
				this.type = val
				if(val != 'quickly_tech'){
					this.tabType = 'basic'
				}else{
					this.tabType = 'extend'
				}
			},
			
			// 小分类点击
			tabClick(val){
				this.tab = val
			},			
			
			// 刷新
			refresh(){
				this.$refs.cirl.refresh()
			},
			
			// 快捷语页面回调
			replyEditCall(data){
				this.showEdit = false
				if(data.type === 'insert'){
					this.refresh()
				}
			},
			
			// 快捷语点击回调
			replyClickCall(data){
				this.$emit('reply-click-call', data)
			}
		},
		created() {
			let quicklyTechPlug = getLocalConfig("quicklyTechPlug")
			if(quicklyTechPlug == 1){
				this.quicklyTechPlug = 1
			}
		}
	}
</script>

<style>
	.reply-box{
		position: relative;
		height: 100%;
		width: 300px;
		overflow: hidden;
	}
	.reply-box .reply-selected-types{
		width: 300px;
		height: 40px;
		text-align: center;
		font-size: 14px;
		display: flex;
	}
	.reply-box .reply-selected-types::before,.reply-box .reply-selected-types::after{
		content: '';
		display: block;
		clear: both;
	}
	.reply-selected-types .reply-selected-type{
		height: 38px;
		line-height: 38px;
		border-bottom: 2px solid #dedede;
		float: left;
		cursor: pointer;
		flex: 1;
	}
	.reply-selected-types .reply-selected-type-active{
		color: #2bad37;
		border-bottom: 2px solid #2bad37;
	}
	.reply-box .reply-selected-tabs{
		width: 300px;
		height: 40px;
		text-align: center;
		font-size: 14px;
	}
	.reply-selected-tabs::before,.reply-selected-tabs::after{
		content: '';
		display: block;
		clear: both;
	}
	.reply-selected-tabs .reply-selected-tab{
		width: 33.3%;
		height: 38px;
		line-height: 38px;
		border-bottom: 1px solid #dedede;
		float: left;
		cursor: pointer;
	}
	.reply-selected-tabs .reply-selected-tab-active{
		color: #2bad37;
		border-bottom: 1px solid #2bad37;
	}
	.reply-box .reply-selected-search{
		width: 280px;
		height: 28px;
		padding: 6px 10px;
		margin-top: 10px;
	}
	.reply-selected-search::before,.reply-selected-search::after{
		display: block;
		content: '';
		clear: both;
	}
	.reply-selected-search .reply-search-input{
		width: 200px;
		height: 28px;
		position: relative;
		float: left;
	}
	.reply-search-input::before{
		content: '';
		position: absolute;
		top: 6px;
		left: 6px;
		width: 16px;
		height: 16px;
		display: block;
		background: url(../../../assets/img/c-all-search.png) no-repeat;
		background-size: 100% auto;
		background-position: center;
	}
	.reply-search-input input{
		border: 1px solid #dedede;
		width: 100%;
		height: 26px;
		outline: none;
		text-indent: 25px;
		font-size: 12px;
		border-radius: 4px;
	}
	.reply-search-input input:focus{
		border: 1px solid #2bad37;
	}
	.reply-selected-search .reply-refresh{
		width: 24px;
		height: 24px;
		float: left;
		margin-left: 5px;
		padding: 2px;
	}
	.reply-refresh span{
		display: block;
		width: 24px;
		height: 24px;
		background-image: url(../../../assets/img/refresh.png);
		background-repeat: no-repeat;
		background-position: center;
		background-size: 100% 100%;
		cursor: pointer;
	}
	.reply-refresh .reply-add{
		background-image: url(../../../assets/img/add-icon-2bad37-32.png) !important;
		background-size: 20px auto;
	}
	.reply-box .reply-selected-lists{
		position: absolute;
		top: 134px;
		bottom: 0;
		left: 10px;
		right: 10px;
	}
	.reply-selected-lists .reply-selected-wrap{
		width: 260px;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.reply-selected-wrap::-webkit-scrollbar {/*滚动条整体样式*/
		width: 6px;     /*高宽分别对应横竖滚动条的尺寸*/
		height: 6px;
		scrollbar-arrow-color:red;
	}
	.reply-selected-wrap::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
		border-radius: 5px;
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		background: rgba(143, 143, 143, 51);
		scrollbar-arrow-color:red;
	}
	.reply-selected-wrap::-webkit-scrollbar-track {/*滚动条里面轨道*/
		border-radius: 0;
		background: rgba(213, 213, 213, 127);
	}
</style>
